import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './NewSalesUploadFile.css';

const NEW_SALES_ROOT = process.env.REACT_APP_NEW_SALES_BASE || '/new-sales';

function NewSalesUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={NEW_SALES_ROOT}
      sessionPrefix="new_sales_file"
    />
  );
}

NewSalesUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default NewSalesUploadFile;
